<template>
  <div class="pg-root">
    <div class="pg-grain" aria-hidden="true"></div>

    <v-snackbar v-model="showSnackBar" color="#7f1d1d" top right :timeout="timeout">
      <div style="display:flex;align-items:center;gap:8px;">
        <v-icon small color="white">mdi-alert-circle</v-icon>
        <span style="font-weight:600;">{{ msg }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="showSnackBar = false">
          <v-icon small color="white">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- LEFT: cinematic frame -->
    <section class="pg-stage d-none d-md-flex">
      <img src="../../assets/Images/ibimage12.jpg" alt="" class="pg-stage-img" />
      <div class="pg-stage-shade"></div>

      <div class="pg-vf" aria-hidden="true">
        <span class="pg-vf-c pg-vf-c--tl"></span>
        <span class="pg-vf-c pg-vf-c--tr"></span>
        <span class="pg-vf-c pg-vf-c--bl"></span>
        <span class="pg-vf-c pg-vf-c--br"></span>
        <span class="pg-vf-rec"><i></i> REC</span>
        <span class="pg-vf-tc">{{ timecode }}</span>
      </div>

      <div class="pg-stage-top">
        <router-link to="/" class="pg-brand">
          <span class="pg-brand-mark"><img src="../../assets/Images/ecoframe_logo.png" alt="ECOFRAME" /></span>
          <span class="pg-brand-text">
            <span class="pg-brand-name">ECOFRAME</span>
            <span class="pg-brand-sub">Kerala Forest Department</span>
          </span>
        </router-link>
        <router-link to="/" class="pg-back">
          <v-icon small color="#e9f5ee">mdi-arrow-left</v-icon>
          Back to site
        </router-link>
      </div>

      <div class="pg-stage-copy">
        <div class="pg-eyebrow"><span></span>Official Film Shooting Portal</div>
        <h1 class="pg-headline">
          Start your<br />
          <em>production journey.</em>
        </h1>
        <p class="pg-lead">Create your ECOFRAME account and apply for film shooting permits in Kerala's forests â€” entirely online.</p>

        <div class="pg-note">
          <span class="pg-note-emblem"><img src="../../assets/Images/blacklogo.png" alt="" /></span>
          <span class="pg-note-text">
            <span class="pg-note-title">Kerala Forest Department</span>
            <span class="pg-note-sub">Government of Kerala Â· Secure official portal</span>
          </span>
          <v-icon color="#4ade80">mdi-shield-check-outline</v-icon>
        </div>
      </div>
    </section>

    <!-- RIGHT: register -->
    <section class="pg-panel">
      <div class="pg-orb pg-orb--1" aria-hidden="true"></div>
      <div class="pg-orb pg-orb--2" aria-hidden="true"></div>
      <div class="pg-orb pg-orb--3" aria-hidden="true"></div>
      <div class="pg-dots" aria-hidden="true"></div>
      <div class="pg-panel-top">
        <router-link to="/" class="pg-brand d-flex d-md-none">
          <span class="pg-brand-mark"><img src="../../assets/Images/ecoframe_logo.png" alt="ECOFRAME" /></span>
          <span class="pg-brand-name">ECOFRAME</span>
        </router-link>
        <span class="pg-secure">
          <v-icon x-small color="#d6b97b">mdi-lock-outline</v-icon>
          Encrypted sign-up
        </span>
      </div>

      <div class="pg-panel-body">
        <div class="pg-card">
          <div class="pg-card-clap" aria-hidden="true"></div>

          <form class="pg-form" @submit.prevent="validateInput">
            <div class="pg-card-head">
              <span class="pg-card-kicker">Scene 01 Â· New Account</span>
              <h2 class="pg-card-title">Create account</h2>
              <p class="pg-card-sub">Join ECOFRAME to apply for and track your shooting permits.</p>
            </div>

            <label class="pg-field">
              <span class="pg-label">Full name</span>
              <span class="pg-box">
                <v-icon small class="pg-box-icon">mdi-account-outline</v-icon>
                <input v-model="username" type="text" class="pg-input" placeholder="Your full name" autocomplete="name" />
              </span>
            </label>

            <label class="pg-field">
              <span class="pg-label">Email address</span>
              <span class="pg-box">
                <v-icon small class="pg-box-icon">mdi-email-outline</v-icon>
                <input v-model="emailId" type="email" class="pg-input" placeholder="you@example.com" autocomplete="email" />
              </span>
            </label>

            <label class="pg-field">
              <span class="pg-label">Phone number</span>
              <span class="pg-box">
                <v-icon small class="pg-box-icon">mdi-phone-outline</v-icon>
                <input v-model="mobNumber" type="tel" class="pg-input" placeholder="10-digit mobile number" autocomplete="tel" maxlength="10" />
              </span>
            </label>

            <label class="pg-field">
              <span class="pg-label">Password</span>
              <span class="pg-box">
                <v-icon small class="pg-box-icon">mdi-lock-outline</v-icon>
                <input v-model="password" :type="showPassword ? 'text' : 'password'" class="pg-input" placeholder="Create a password" autocomplete="new-password" />
                <button type="button" class="pg-eye" :aria-label="showPassword ? 'Hide' : 'Show'" @click="showPassword = !showPassword">
                  <v-icon small color="#9db3a6">{{ showPassword ? "mdi-eye-outline" : "mdi-eye-off-outline" }}</v-icon>
                </button>
              </span>
            </label>

            <label class="pg-field">
              <span class="pg-label">Confirm password</span>
              <span class="pg-box" :class="{ 'pg-box--error': confirmpassword && !arePasswordsMatching }">
                <v-icon small class="pg-box-icon">mdi-lock-check-outline</v-icon>
                <input v-model="confirmpassword" :type="showPassword2 ? 'text' : 'password'" class="pg-input" placeholder="Re-enter your password" autocomplete="new-password" />
                <button type="button" class="pg-eye" :aria-label="showPassword2 ? 'Hide' : 'Show'" @click="showPassword2 = !showPassword2">
                  <v-icon small color="#9db3a6">{{ showPassword2 ? "mdi-eye-outline" : "mdi-eye-off-outline" }}</v-icon>
                </button>
              </span>
              <span v-if="confirmpassword && !arePasswordsMatching" class="pg-field-error">
                <v-icon x-small color="#f87171">mdi-alert-circle-outline</v-icon>
                Passwords do not match
              </span>
            </label>

            <button type="submit" class="pg-btn" :disabled="loading || Boolean(confirmpassword && !arePasswordsMatching)">
              <template v-if="!loading">
                Create account
                <v-icon small color="#03140a">mdi-arrow-right</v-icon>
              </template>
              <template v-else>
                <v-icon small color="#03140a" class="pg-spin">mdi-loading</v-icon>
                Creating accountâ€¦
              </template>
            </button>

            <div class="pg-divider"><span></span><em>Already on ECOFRAME?</em><span></span></div>

            <router-link to="/login" class="pg-btn pg-btn--ghost">Sign in instead</router-link>
          </form>
        </div>

        <ul class="pg-perks">
          <li v-for="f in features" :key="f">
            <span class="pg-perk-mark"></span>
            {{ f }}
          </li>
        </ul>
      </div>

      <div class="pg-panel-foot">
        Â© {{ year }} Kerala Forest Department Â· Developed by <strong>Leopard Tech Labs Pvt. Ltd.</strong>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      emailId: null,
      mobNumber: null,
      showPassword: false,
      showPassword2: false,
      username: null,
      password: null,
      confirmpassword: null,
      loading: false,
      frame: 0,
      features: ["Free to register", "Online permit tracking", "e-Treasury payments"],
    };
  },
  computed: {
    year() { return new Date().getFullYear(); },
    arePasswordsMatching() { return this.password === this.confirmpassword; },
    timecode() {
      const f = this.frame;
      const pad = (n) => String(n).padStart(2, "0");
      const secs = Math.floor(f / 24);
      return [Math.floor(secs / 3600), Math.floor(secs / 60) % 60, secs % 60, f % 24].map(pad).join(":");
    },
  },
  mounted() {
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduce) this.timer = setInterval(() => (this.frame += 1), 1000 / 24);
  },
  beforeDestroy() { clearInterval(this.timer); },
  methods: {
    validateInput() {
      if (this.loading) return;
      if (!this.username) { this.msg = "Please enter your full name."; this.showSnackBar = true; return; }
      if (!this.emailId) { this.msg = "Please enter your email address."; this.showSnackBar = true; return; }
      if (!this.isValidEmail(this.emailId)) { this.msg = "Please enter a valid email address."; this.showSnackBar = true; return; }
      if (!this.mobNumber) { this.msg = "Please enter your phone number."; this.showSnackBar = true; return; }
      if (!this.isValidMobileNumber(this.mobNumber)) { this.msg = "Please enter a valid 10-digit mobile number."; this.showSnackBar = true; return; }
      if (!this.password) { this.msg = "Please create a password."; this.showSnackBar = true; return; }
      if (!this.confirmpassword) { this.msg = "Please confirm your password."; this.showSnackBar = true; return; }
      if (!this.arePasswordsMatching) { this.msg = "Passwords do not match."; this.showSnackBar = true; return; }
      this.register();
    },
    isValidEmail(email) { return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email); },
    isValidMobileNumber(mob) { return /^[0-9]{10}$/.test(mob); },
    register() {
      this.loading = true;
      axios({ method: "POST", url: "/add/user", headers: { token: localStorage.getItem("token") },
        data: { username: this.username, officeName: this.username, password: this.password, mobNumber: this.mobNumber, emailId: this.emailId },
      }).then((response) => {
        this.loading = false;
        if (response.data.status == true) {
          this.msg = response.data.msg;
          const userId = response.data.data._id;
          this.showSnackBar = true;
          setTimeout(() => { this.$router.push({ path: "/verify", query: { userId } }); }, 3000);
        } else {
          this.msg = response.data.msg;
          this.showSnackBar = true;
        }
      }).catch((err) => {
        this.loading = false;
        this.ServerError = true;
        console.error(err);
      });
    },
  },
};
</script>

<style scoped>

.pg-root {
  --bg: #03100a;
  --line: rgba(233, 245, 238, 0.1);
  --line-strong: rgba(233, 245, 238, 0.18);
  --emerald: #22c55e;
  --emerald-soft: #4ade80;
  --gold: #d6b97b;
  --ink: #e9f5ee;
  --muted: #9db3a6;
  position: relative;
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  font-family: "Inter", sans-serif;
  background: var(--bg);
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
}
.pg-root a { text-decoration: none; }
@media (max-width: 959px) { .pg-root { grid-template-columns: 1fr; } }

.pg-grain {
  position: fixed; inset: 0; z-index: 5; pointer-events: none; opacity: 0.07; mix-blend-mode: overlay;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>");
}

.pg-brand { display: flex; align-items: center; gap: 12px; }
.pg-brand-mark { width: 42px; height: 42px; border-radius: 12px; background: #fff; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; box-shadow: 0 0 0 1px rgba(214,185,123,0.45), 0 8px 20px rgba(0,0,0,0.35); }
.pg-brand-mark img { width: 86%; height: 86%; object-fit: contain; }
.pg-brand-text { display: flex; flex-direction: column; line-height: 1.15; }
.pg-brand-name { font-size: 15px; font-weight: 700; letter-spacing: 4px; color: var(--ink); }
.pg-brand-sub { font-size: 10.5px; font-weight: 500; letter-spacing: 1.6px; text-transform: uppercase; color: rgba(233,245,238,0.7); }

.pg-stage {
  position: relative; overflow: hidden; min-height: 100vh;
  flex-direction: column; justify-content: space-between;
  padding: 44px clamp(44px,5vw,80px) clamp(56px,8vh,88px);
}
.pg-stage-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; animation: pgDrift 30s ease-in-out infinite alternate; }
@keyframes pgDrift { from { transform: scale(1.05); } to { transform: scale(1.14) translate3d(-1.5%,-1%,0); } }
.pg-stage-shade {
  position: absolute; inset: 0;
  background:
    linear-gradient(180deg, rgba(3,16,10,0.6) 0%, rgba(3,16,10,0.1) 30%, rgba(3,16,10,0.35) 60%, rgba(3,16,10,0.95) 100%),
    linear-gradient(90deg, rgba(3,16,10,0.35), transparent 60%);
}
.pg-vf { position: absolute; inset: 22px; pointer-events: none; opacity: 0.8; }
.pg-vf-c { position: absolute; width: 26px; height: 26px; border: 0 solid rgba(233,245,238,0.55); }
.pg-vf-c--tl { top: 0; left: 0; border-top-width: 1px; border-left-width: 1px; }
.pg-vf-c--tr { top: 0; right: 0; border-top-width: 1px; border-right-width: 1px; }
.pg-vf-c--bl { bottom: 0; left: 0; border-bottom-width: 1px; border-left-width: 1px; }
.pg-vf-c--br { bottom: 0; right: 0; border-bottom-width: 1px; border-right-width: 1px; }
.pg-vf-rec, .pg-vf-tc {
  position: absolute; bottom: 12px; display: inline-flex; align-items: center; gap: 7px;
  font-family: "Inter", sans-serif; font-size: 11.5px; letter-spacing: 1.5px; color: rgba(233,245,238,0.75);
}
.pg-vf-rec { left: 40px; }
.pg-vf-tc { right: 40px; }
.pg-vf-rec i { width: 7px; height: 7px; border-radius: 50%; background: #ef4444; box-shadow: 0 0 10px #ef4444; animation: pgBlink 1.4s steps(2,start) infinite; }
@keyframes pgBlink { to { visibility: hidden; } }

.pg-stage-top { position: relative; z-index: 2; display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.pg-back {
  display: inline-flex; align-items: center; gap: 6px; padding: 9px 16px; border-radius: 999px;
  background: rgba(255,255,255,0.08); border: 1px solid var(--line-strong);
  backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
  color: var(--ink); font-size: 13px; font-weight: 500; transition: background 0.2s;
}
.pg-back:hover { background: rgba(255,255,255,0.16); }

.pg-stage-copy { position: relative; z-index: 2; max-width: 560px; }
.pg-stage-copy > * { animation: pgRise 1s cubic-bezier(0.2,0.7,0.2,1) both; }
.pg-stage-copy > *:nth-child(2) { animation-delay: 0.1s; }
.pg-stage-copy > *:nth-child(3) { animation-delay: 0.2s; }
.pg-stage-copy > *:nth-child(4) { animation-delay: 0.3s; }
@keyframes pgRise { from { opacity: 0; transform: translateY(22px); } to { opacity: 1; transform: none; } }
.pg-eyebrow { display: flex; align-items: center; gap: 14px; margin-bottom: 22px; font-size: 11.5px; font-weight: 600; letter-spacing: 2.6px; text-transform: uppercase; color: var(--gold); }
.pg-eyebrow span { width: 40px; height: 1px; background: linear-gradient(90deg, var(--gold), transparent); }
.pg-headline { font-family: "Inter", sans-serif; font-weight: 500; font-size: clamp(42px,4.6vw,70px); line-height: 1.04; letter-spacing: -1px; margin: 0 0 18px; color: #f4faf6; }
.pg-headline em { font-style: italic; color: var(--emerald-soft); }
.pg-lead { max-width: 470px; margin: 0 0 32px; font-size: 16.5px; font-weight: 300; line-height: 1.7; color: rgba(233,245,238,0.82); }
.pg-note {
  display: flex; align-items: center; gap: 14px; max-width: 440px; padding: 14px 18px; border-radius: 18px;
  background: rgba(255,255,255,0.08); border: 1px solid var(--line-strong);
  backdrop-filter: blur(18px); -webkit-backdrop-filter: blur(18px);
}
.pg-note-emblem { width: 42px; height: 42px; border-radius: 50%; background: #fff; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
.pg-note-emblem img { width: 76%; height: 76%; object-fit: contain; }
.pg-note-text { display: flex; flex-direction: column; flex: 1; line-height: 1.35; }
.pg-note-title { font-size: 14px; font-weight: 600; }
.pg-note-sub { font-size: 12px; color: rgba(233,245,238,0.7); }

.pg-panel {
  position: relative; min-height: 100vh; display: flex; flex-direction: column;
  background: var(--bg);
  overflow: hidden;
}

/* Ambient floating orbs */
.pg-orb { position: absolute; border-radius: 50%; pointer-events: none; filter: blur(80px); }
.pg-orb--1 { width: 420px; height: 420px; top: -100px; right: -100px; background: radial-gradient(circle, rgba(34,197,94,0.22) 0%, transparent 70%); animation: pgOrbDrift1 14s ease-in-out infinite alternate; }
.pg-orb--2 { width: 320px; height: 320px; bottom: 60px; left: -80px; background: radial-gradient(circle, rgba(214,185,123,0.18) 0%, transparent 70%); animation: pgOrbDrift2 18s ease-in-out infinite alternate; }
.pg-orb--3 { width: 240px; height: 240px; top: 45%; right: 10%; background: radial-gradient(circle, rgba(74,222,128,0.12) 0%, transparent 70%); animation: pgOrbDrift3 11s ease-in-out infinite alternate; }
@keyframes pgOrbDrift1 { from { transform: translate(0,0) scale(1); } to { transform: translate(-30px,40px) scale(1.1); } }
@keyframes pgOrbDrift2 { from { transform: translate(0,0) scale(1); } to { transform: translate(20px,-30px) scale(0.9); } }
@keyframes pgOrbDrift3 { from { transform: translate(0,0); } to { transform: translate(-20px,20px); } }

/* Dot matrix background */
.pg-dots { position: absolute; inset: 0; pointer-events: none; opacity: 0.18; background-image: radial-gradient(circle, rgba(233,245,238,0.55) 1px, transparent 1px); background-size: 28px 28px; }
.pg-panel-top { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 30px clamp(20px,4vw,56px) 0; }
.pg-secure { margin-left: auto; display: inline-flex; align-items: center; gap: 6px; font-size: 11.5px; font-weight: 600; letter-spacing: 1.6px; text-transform: uppercase; color: var(--muted); }
.pg-panel-body { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 24px clamp(20px,4vw,56px); }

.pg-card {
  position: relative; width: 100%; max-width: 440px; border-radius: 26px; overflow: hidden;
  background: linear-gradient(165deg, rgba(255,255,255,0.09) 0%, rgba(255,255,255,0.03) 100%);
  border: 1px solid var(--line-strong);
  box-shadow: 0 40px 90px rgba(0,0,0,0.6), 0 0 0 1px rgba(74,222,128,0.06) inset, inset 0 1px 0 rgba(255,255,255,0.12);
  animation: pgRise 0.9s cubic-bezier(0.2,0.7,0.2,1) both;
  backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);
}
.pg-card::before { content: ""; position: absolute; inset: 0; border-radius: 26px; padding: 1px; background: linear-gradient(150deg, rgba(214,185,123,0.7), transparent 35%, transparent 70%, rgba(74,222,128,0.5)); -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0); -webkit-mask-composite: xor; mask-composite: exclude; pointer-events: none; animation: pgShimmer 5s ease-in-out infinite alternate; }
@keyframes pgShimmer { from { opacity: 0.7; } to { opacity: 1; } }
.pg-card::after { content: ""; position: absolute; top: 0; left: -60%; width: 40%; height: 100%; background: linear-gradient(90deg, transparent, rgba(255,255,255,0.04), transparent); transform: skewX(-15deg); animation: pgSweep 8s ease-in-out 2s infinite; pointer-events: none; border-radius: 26px; }
@keyframes pgSweep { 0%,100% { left: -60%; opacity: 0; } 10% { opacity: 1; } 40% { left: 140%; opacity: 0; } }
.pg-card-clap { height: 7px; background: repeating-linear-gradient(115deg, rgba(233,245,238,0.9) 0 12px, rgba(74,222,128,0.4) 12px 14px, transparent 14px 26px); opacity: 0.7; position: relative; }
.pg-card-clap::after { content: ""; position: absolute; inset: 0; background: linear-gradient(90deg, transparent, rgba(74,222,128,0.3), transparent); animation: pgClapScan 3s ease-in-out infinite; }
@keyframes pgClapScan { 0%,100% { opacity: 0; transform: translateX(-100%); } 50% { opacity: 1; transform: translateX(100%); } }

.pg-form { display: flex; flex-direction: column; gap: 14px; padding: 24px clamp(22px,4vw,38px) 28px; }
.pg-card-head { margin-bottom: 2px; }
.pg-card-kicker { display: block; margin-bottom: 10px; font-size: 11px; font-weight: 600; letter-spacing: 2.6px; text-transform: uppercase; color: var(--gold); }
.pg-card-title { font-family: "Inter", sans-serif; font-weight: 500; font-size: 32px; line-height: 1.1; letter-spacing: -0.5px; margin: 0 0 6px; color: #f4faf6; }
.pg-card-sub { margin: 0; font-size: 13.5px; font-weight: 300; line-height: 1.6; color: var(--muted); }

.pg-field { display: flex; flex-direction: column; gap: 6px; }
.pg-label { font-size: 12px; font-weight: 500; letter-spacing: 0.3px; color: rgba(233,245,238,0.85); }
.pg-box {
  display: flex; align-items: center; gap: 10px; padding: 0 14px;
  background: rgba(1,8,5,0.6); border: 1px solid var(--line-strong); border-radius: 12px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
}
.pg-box:hover { border-color: rgba(233,245,238,0.3); background: rgba(1,8,5,0.7); }
.pg-box:focus-within { border-color: var(--emerald-soft); background: rgba(1,8,5,0.8); box-shadow: 0 0 0 4px rgba(74,222,128,0.15), 0 0 20px rgba(74,222,128,0.08); }
.pg-box--error { border-color: rgba(248,113,113,0.6) !important; box-shadow: 0 0 0 4px rgba(248,113,113,0.12) !important; }
.pg-box-icon { color: var(--muted) !important; flex-shrink: 0; transition: color 0.3s ease; }
.pg-box:focus-within .pg-box-icon { color: var(--emerald-soft) !important; }
.pg-input { flex: 1; min-width: 0; padding: 12px 0; border: none; outline: none; background: transparent; color: var(--ink); font-family: inherit; font-size: 14.5px; }
.pg-input::placeholder { color: rgba(157,179,166,0.55); }
.pg-input:-webkit-autofill { -webkit-text-fill-color: var(--ink); -webkit-box-shadow: 0 0 0 40px #06150d inset; caret-color: var(--ink); }
.pg-eye { display: flex; padding: 4px; border: none; background: none; cursor: pointer; flex-shrink: 0; }
.pg-field-error { display: inline-flex; align-items: center; gap: 5px; font-size: 11.5px; color: #f87171; }

.pg-btn {
  display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%;
  margin-top: 2px; padding: 14px; border: none; border-radius: 999px; cursor: pointer;
  background: linear-gradient(135deg, #4ade80 0%, #22c55e 50%, #16a34a 100%);
  color: #03140a; font-family: inherit; font-size: 15px; font-weight: 700; letter-spacing: 0.3px;
  box-shadow: 0 1px 0 rgba(255,255,255,0.5) inset, 0 14px 34px rgba(34,197,94,0.38);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  animation: pgBtnPulse 3s ease-in-out infinite;
  position: relative; overflow: hidden;
}
.pg-btn::after { content: ""; position: absolute; inset: 0; border-radius: 999px; background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent); transform: translateX(-100%); transition: transform 0.6s ease; }
.pg-btn:hover::after { transform: translateX(100%); }
@keyframes pgBtnPulse { 0%,100% { box-shadow: 0 1px 0 rgba(255,255,255,0.5) inset, 0 14px 34px rgba(34,197,94,0.38), 0 0 0 0 rgba(74,222,128,0); } 50% { box-shadow: 0 1px 0 rgba(255,255,255,0.5) inset, 0 14px 34px rgba(34,197,94,0.38), 0 0 20px 4px rgba(74,222,128,0.18); } }
.pg-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 1px 0 rgba(255,255,255,0.5) inset, 0 22px 50px rgba(34,197,94,0.5), 0 0 30px rgba(74,222,128,0.25); animation: none; }
.pg-btn:disabled { opacity: 0.7; cursor: not-allowed; animation: none; }
.pg-btn .v-icon { transition: transform 0.25s ease; }
.pg-btn:hover .v-icon { transform: translateX(4px); }
.pg-btn--ghost { margin-top: 0; background: transparent; color: var(--ink); border: 1px solid var(--line-strong); box-shadow: none; font-size: 14px; font-weight: 500; animation: none; }
.pg-btn--ghost::after { display: none; }
.pg-btn--ghost:hover:not(:disabled) { background: rgba(255,255,255,0.06); border-color: rgba(214,185,123,0.7); box-shadow: 0 0 20px rgba(214,185,123,0.1); }
.pg-spin { animation: pgSpin 0.8s linear infinite; }
@keyframes pgSpin { to { transform: rotate(360deg); } }

.pg-divider { display: flex; align-items: center; gap: 14px; }
.pg-divider span { flex: 1; height: 1px; background: var(--line); }
.pg-divider em { font-style: normal; font-size: 12px; color: var(--muted); white-space: nowrap; }

.pg-perks { list-style: none; display: flex; flex-wrap: wrap; justify-content: center; gap: 10px 26px; margin: 20px 0 0; padding: 0; }
.pg-perks li { display: inline-flex; align-items: center; gap: 9px; font-size: 13px; color: var(--muted); }
.pg-perk-mark { width: 6px; height: 6px; transform: rotate(45deg); background: var(--gold); flex-shrink: 0; }

.pg-panel-foot { padding: 0 20px 24px; text-align: center; font-size: 12px; color: rgba(157,179,166,0.65); }
.pg-panel-foot strong { font-weight: 500; color: var(--muted); }

@media (max-width: 480px) {
  .pg-secure { display: none; }
  .pg-card-title { font-size: 26px; }
  .pg-form { padding: 22px 20px 26px; }
}
@media (prefers-reduced-motion: reduce) {
  .pg-stage-img, .pg-stage-copy > *, .pg-card, .pg-vf-rec i { animation: none; }
}
</style>
